import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { SubGenre } from '../../models/SubGenre';
export interface GenreResponse {
  status: string;
  message: string;
  data: SubGenre[];
}
const config = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const service = {
  addSubGenre(body: any): Promise<CommonResponse<SubGenre>> {
    const url = `sub-genre`;
    return axiosClient.post(url, body, config);
  },
};

export default service;
